<template>
  <div class="p-5">

    <div
      v-for="category in goal_categories"
      v-if="$ready_goals"
      :key="category.$key"
      class="goal-category mb-5 clearfix">
      <div class="goal-category__header">
        <!-- <h3 class="m-0">{{category.name}}</h3> -->

        <h3 class="m-0">
          <inline-editable-text
            @change="onUpdateCategoryName( category.$id, $event)"
            :is-editable="category.$key !== 'unassigned'"
            :class="{ 'unassigned-category': category.$key === 'unassigned' }"
            :value="category.name"
            :resetOnCancel="false"
            :inline="true" />
        </h3>

        <div>
          <!-- automatic Planning: -->
          <inline-timeslot-collection-selector
            v-if="category.$key !== 'unassigned'"
            :value="category.defaultTimeslotCollectionId"
            @input="onChangeDefaultTimeslotCollection( category.$id, $event )" />
        </div>
      </div>

      <div
        v-if="category.$key === 'unassigned'"
        style="display: flex; justify-content: center; padding: padding: 3em 0 4em 0px;">
        <el-button @click="onCreateCategory" size="normal">
          <font-awesome-icon :icon="['fas', 'plus-circle']" />
          Create new category
        </el-button>
        <el-button @click="onPrioritizeWeekdayPreferences" size="normal">
          <font-awesome-icon icon="list-ol" />
          Organize categories
        </el-button>
      </div>

      <sortable-card-grid
        :value="getUserGoalByCategoryId( category.$id )"
        :list-id="category.$id"
        list-id-param="categoryId"
        add-card-text="New Goal"
        @item-add="onAddGoal( category.$id )"
        @list-reorder="onItemsReorder"
        @list-move="onItemChangeList( $event, category.$id )"
        />
    </div>

    <div class="goal-category mb-5 clearfix" v-if="goal_invite_list.length > 0">
      <div class="goal-category__header">
        <h3 class="m-0">Invitations</h3>
      </div>
      <el-card
        v-for="(invitation, invitation_idx) in goal_invite_list"
        :key="'invitation'+invitation_idx"
        class="inline-goal-card inline-goal-card--variable-height">
        <div>
          <p style="font-size: 10pt">
            <!-- {{invitation.cachedGoalName}}: -->
            You got an invitation to <strong>{{invitation.cachedGoalName}}</strong>
            from <strong>{{invitation.cachedSenderName}}.</strong><br /><br />
            <span>{{invitation.invitedAt|calendarDateFromFirebase}}</span>
          </p>
          <el-button-group>
            <el-button size="mini" @click="onAcceptOrDeclineInvitation(invitation.id, invitation.cachedGoalName, true)">Accept</el-button>
            <el-button size="mini" @click="onAcceptOrDeclineInvitation(invitation.id, invitation.cachedGoalName, false)" type="danger">Decline</el-button>
          </el-button-group>
        </div>
      </el-card>
    </div>

    <div class="goal-category mb-5 clearfix">
      <div class="goal-category__header">
        <h3 class="m-0">Achieved goals</h3>
      </div>

      <el-button type="text" @click="show_archived_goals = !show_archived_goals">
        {{ show_archived_goals ? 'Hide achieved goals' : 'Show achieved goals' }}
      </el-button>

      <div v-if="show_archived_goals">
        <InlineGoalCard
          v-for="goal in archived_goal_settings"
          :key="goal.$key"
          :goal="goal"
          />
        <!-- TODO: Show restore archived goal option -->
        <div v-if="archived_goal_settings.length === 0">
          No achieved goals.
        </div>
      </div>
    </div>

    <!--
    <h2 class="mt-8">Team goals</h2>
    <hr />

    <div class="clearfix" v-if="$ready_goals">
      <InlineGoalCard
        v-for="goal in team_user_goal_settings"
        :key="goal.$key"
        :goal="goal"
        />

      <el-card class="inline-goal-card inline-goal-card--dashed" @click.native="onAddGoal(true)" >
        <div class="text-center pt-6">
          <div><font-awesome-icon size="3x" :icon="['fas', 'plus-circle']"/></div>
          <div>New Team Goal</div>
        </div>
      </el-card>
    </div>
    -->

    <!--
    <pre class="mini-pre">{{ goal_meta_map }}</pre>
    <pre class="mini-pre">{{ goal_categories }}</pre>
    <pre class="mini-pre">{{ archived_goal_settings }}</pre>
    <pre class="mini-pre">{{ goal_invite_list }}</pre>
    <pre>goal_id_list: {{goal_id_list}}</pre>
    <pre>all_goal_meta: {{all_goal_meta}}</pre>
    <pre>user_goal_settings: {{user_goal_settings}}</pre>
    <pre>full_state: {{full_state}}</pre>
    -->

    <PrioritiesModal
      ref="categorySortModal"
      title="Sort categories"
      @save="onSavePriorities">
    </PrioritiesModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapReady } from '@/api/misc'
import InlineGoalCard from '@/components/GoalPage/Elements/InlineGoalCard'
import PrioritiesModal from '@/components/CalendarPage/Legacy/Elements/PrioritiesModal'
// import util from '@/util'
import GoalManagementMixin from "@/components/Mixins/GoalManagement"

export default {
  name: "GoalOverviewPage",
  mixins: [ GoalManagementMixin ],
  data: () => ({
    show_archived_goals: false
  }),
  created() {
  },
  computed: {
    ...mapReady('goals'),
    ...mapGetters("user", [
      "userData"
    ]),
    /*
    team_user_goal_settings() {
      const map = this.goal_meta_map
      return this.user_goal_settings
        .itemsAsArray()
        .filter( item => !map[ item.$id ].deleted && map[ item.$id ].team )
    },
    */
    archived_goal_settings() {
      return this.user_goal_settings
        .itemsAsArray()
        .filter( item => this.goal_meta_map[ item.$id ].deleted )
    },
    goal_invite_list() {
      // TODO:
      let user = this.userData;
      if (user && 'goalInviteList' in user) {
        return Object.keys(user.goalInviteList).map(key => {
          return { ...user.goalInviteList[key], id: key };
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    onItemChangeList(foreignItems, newCategoryId) {
      foreignItems.forEach(item => {

        // item.clone();
        // item.categoryId = newCategoryId;
        // item.write();
        this.$models.userGoalSettings.update(item.$id, { categoryId: newCategoryId });
      })
    },
    onItemsReorder(reorderedItems) {
      let batch = reorderedItems.map(item => item.$id)
      this.$models.userGoalSettings.reorder(batch)
    },
    onAcceptOrDeclineInvitation(invitation_id, invitation_name, accept) {
      console.error("NOT_IMPLEMENTED")
      /* this.$api.accept_or_decline_invitation({
        goal_id: invitation_id,
        goal_name: invitation_name,
        accept: accept
      }) */
    },
    onUpdateCategoryName( categoryId, value ) {
      if ( categoryId ) {
        this.$models.userGoalCategory.update( categoryId, {
          name: value
        })
      }
    },
    onChangeDefaultTimeslotCollection( categoryId, value ) {
      // console.log("onChangeDefaultTimeslotCollection", categoryId, value)
      this.$models.userGoalCategory.update( categoryId, {
        defaultTimeslotCollectionId: value
      })
    },
    onCreateCategory() {
      this.$root.showNewModal('goal-category');
    },
    onPrioritizeWeekdayPreferences() {
      // let categories = this.goal_categories.map((category) => {
      //   return { ...category };
      // });

      let categories = this.goal_categories.filter(category => category.$id );
      this.$refs.categorySortModal.open( categories );
    },
    onSavePriorities( reorderedItems ) {
      // console.log("onSavePriorities", reorderedItems);

      let batch = reorderedItems.map(item => item.$id)
      this.$models.userGoalCategory.reorder(batch)
    },
  },
  components: {
    InlineGoalCard,
    PrioritiesModal,
  }
};
</script>

<style>
.inline-goal-card--dashed {
  border-radius: 5px;
  border-style: dashed;
  border-width: 2px;
  border-color: #AAA;
  color: #AAA;
}
.inline-goal-card--dashed:hover {
  border-color: #777;
  color: #777;
}
.inline-goal-card--dashed > div {
  /* display:flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align:center; */
}
.inline-goal-card--variable-height {
  height: unset;
  min-height: 211px;
}
.goal-category__header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #CCC;
  padding-bottom: 0.25em;
  margin-bottom: 1em;
}
.goal-category h3 .unassigned-category {
  font-weight: 400;
  color: #808080;
}
</style>
